/* eslint-disable no-empty-pattern */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useState } from 'react';
import { ContainerModal, ContainerTD, CustomModal, DivModalFooter, ModalDocumentaionContainer } from './style';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  customer: any;
};


const ModalDataDocumentation: React.FC<Props> = ({ isOpen, onCancel, customer }) => {
  const [files, setFiles] = useState(null);
  const [filesArray, setFilesArray] = useState<{ file: Blob; type: string; name: string, TitularConjuge: string }[]>([]);
  const [typeDocumentation, setTypeDocumentation] = useState('');
  const [countMaxFiles, setMaxFiles] = useState({ typeDocumentation: '', count: 0 });
  const [idFile, setIdFile] = useState('');
  const [errorFiles, setErrorFiles] = useState([]);
  const [internalIsOpen, setInternalIsOpen] = useState(isOpen);
  
  function createdAlert(message) {
    const snackbar = document.createElement("div");
    snackbar.classList.add("snackbar");
    snackbar.innerHTML = message;
    document.body.appendChild(snackbar);

    snackbar.addEventListener("click", () => {
    snackbar.remove();
    });
  }  

  function wait() {
    const progressContainer = document.getElementById("loading-modal");
    progressContainer.style.display = "block";

    progressContainer.style.height = "160px";
    progressContainer.style.width = "100%";
    progressContainer.style.justifyContent = "center";
  }
  function done() {
    const progressContainer = document.getElementById("loading-modal");
    progressContainer.style.display = "none";
  }

    function contarHolerites(array, type) {
        let count = 0;
        for (const obj of array) {
            if (obj.type === type) {
            count++;
            }
        }
        return count;
    }  
    
    function selectFiles(id) {
        const fileInput = document.getElementById(`${id}`);
        fileInput.click();
    }

    function onClickButtonHolerite(file, div, describe, type) {
        const excludedFile = filesArray.findIndex((item) => item.file === file);

        if (excludedFile !== -1) {
            filesArray.splice(excludedFile, 1);
            let parsedFiles = filesArray.filter((fileFilter) => fileFilter.type == type);
            showFilesInDiv(parsedFiles, div, describe, type);
        }
    }
    function showFilesInDiv(array, div, describe, type) {
        if (array.length > 0) {
            div.innerHTML = "";
            for (let i = 0; i < array.length; i++) {
            const buttonHolerite = document.createElement("button");
            buttonHolerite.classList.add("button-file");
            buttonHolerite.innerHTML = `${array[i].name} &times`;

            (function (file) {
                buttonHolerite.addEventListener("click", function () {
                onClickButtonHolerite(file, div, describe, type);
                });
            })(array[i].file);

            div.appendChild(buttonHolerite);
            }
        } else {
            div.innerHTML = describe;
        }
    }

    //@ts-ignore
    function handleFiles(event: any, type: string, id: string) {
        const fileInput = document.getElementById(`${id}`) as HTMLInputElement;
        setTypeDocumentation(type)
        setIdFile(id)
        const filesEvent = fileInput.files[fileInput.files.length - 1];
        const maximoArquivosPorTipo = 3;
        const tamanhoMaximoArquivo = 5 * 1024 * 1024; // 5MB em bytes
        const contagemTipos = {};

        const tamanhoArquivo = fileInput.files[fileInput.files.length - 1].size;

        if (tamanhoArquivo > tamanhoMaximoArquivo) {
            createdAlert(
            "<h2 style='margin-top:1em'>Tamanho do arquivo maior que 5MB.</h2><br><button>Ok</button>"
            );
            return;
        } else {
            const fileParsed = fileInput.files[fileInput.files.length - 1];
            
            setFilesArray(prevFilesArray => [
                ...prevFilesArray,
                {
                file: new Blob([fileParsed], { type: fileParsed.type }),
                type: type,
                name: fileParsed.name,
                TitularConjuge:  '',
                },
            ]);
        }               
  }
  
  function validarArquivosObrigatorios(files) {
    const arquivosObrigatorios = ["HLTEXT", "IDENT", "CERTESTCIV"];
    const tiposArquivosEncontrados = files.map((file) => file.type);

    return arquivosObrigatorios.every((arquivo) =>
      tiposArquivosEncontrados.includes(arquivo)
    );
  }

  function validarArquivosObrigatoriosConjuge(files) {
    const arquivosObrigatorios = ["IDENT"];
    const tiposArquivosEncontrados = files.map((file) => file.type);

    return arquivosObrigatorios.every((arquivo) =>
      tiposArquivosEncontrados.includes(arquivo)
    );
  }

  function validarDocumentosMarital(files, estadoCivil) {
    const documentosMarital = ["IDENT"];
    const tiposArquivosEncontrados = files.map((file) => file.type);

    if (estadoCivil === "Casado(a)") {
      return documentosMarital.every((documento) =>
        tiposArquivosEncontrados.includes(documento)
      );
    }

    return true;
  }
  function parsedFilesToAPi(file, lead) {
    return {
      IdLead: lead.id,
      TipoAnexo: file.type,
      Anexo: file.file,
      TitularConjuge: file.TitularConjuge,
      name: file.name,
    };
  }

  function postDocumentation(file) {
    const api = 'https://apiintegracaoparceiro.oitocreditoimobiliario.com.br//integracaoParceiro/inserirAnexosLead';

    const formData = new FormData();
    const reader = new FileReader();

    formData.append("IdLead", file.IdLead);
    formData.append("TipoAnexo", file.TipoAnexo);
    formData.append("Anexo", file.Anexo, file.name);
    formData.append("TitularConjuge", file.TitularConjuge);

    return new Promise((resolve, reject) => {
      fetch(api, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            setErrorFiles(file)
          }
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }



    function SendDocumentations() {
       if (filesArray.length <= 0) {
            createdAlert(
            "<h2>Atenção</h2> <br> <p>Nenhum documento foi adicionado!</p><br><button>Ok</button>"
            );
        }

        if (!validarArquivosObrigatorios(filesArray)) {
            this.createdAlert(
            "<h2>Atenção</h2> <br> <p>Anexe os documentários necessários do titular da simulação!</p><br><button>Ok</button>"
            );
        } else if (
            !validarDocumentosMarital(filesArray, customer.estadoCivil)
        ) {
            this.createdAlert(
            "<h2>Atenção</h2> <br> <p>Anexe os documentários necessários do cônjuge!</p><br><button>Ok</button>"
            );
        } else {
            wait();
            const promisseFile = filesArray.map((file) => {
            return parsedFilesToAPi(file, customer);
            });

            const requestPost = promisseFile.map(postDocumentation);

            //@ts-ignore
            Promise.all(requestPost)
            .then(() => {
              if (errorFiles.length == 0) {
                done();
                closeAfterPost();
                } else {
                setErrorFiles([]);

                const requestPost = errorFiles.map(postDocumentation);

                //@ts-ignore
                Promise.all(requestPost)
                    .then(() => {
                    closeAfterPost();
                    })
                    .catch((error) => {
                    createdAlert(
                        "<p style='margin-top:1em'>Não foi possível enviar a documentação, por gentileza tente novamente !</p><br><button>Ok</button>"
                    );
                    console.log(error);
                    });
                }
            })
            .catch((error) => {
                done();
                console.error("Erro ao enviar arquivos:", error);
            });
        }
    }
    function closeAfterPost() {
      createdAlert(
            "<h2>Dados recebidos pelo time comercial !</h2> <br> <p>Em até 24 horas um de nossos especialistas entrará em contato !</p><br><button>Ok</button>"
      );
      setFilesArray([]);
      onCancel();
    }
  
  useEffect(() => {
    if (customer) {
      const spouseDiv = document.getElementById("spouse-doc");
      const nameCustomer = document.getElementById("title-customer");
      if (customer.estadoCivil !== "Casado(a)") {
        spouseDiv.style.display = "none";
      } else {
        spouseDiv.style.display = "block";
        nameCustomer.innerHTML =
        "Proponente: " + customer.nome
        " - " + customer.cpf;
      }
    
    }
  },[customer])

  useEffect(() => {
   
    if (!!filesArray.length) {
      const tipoArquivo = filesArray[filesArray.length - 1].type;
      const maximoArquivosPorTipo = 3;

      if (!countMaxFiles.hasOwnProperty(tipoArquivo)) {
        setMaxFiles({ typeDocumentation: typeDocumentation, count: 1 });
      } else {
        setMaxFiles({ typeDocumentation: typeDocumentation, count: countMaxFiles.count + 1 });
      }

      const count = contarHolerites(filesArray, typeDocumentation);
      if (count > maximoArquivosPorTipo) {
        filesArray.splice(filesArray.length - 1, 1);
        createdAlert(
          `<h2 style='margin-top:1em'>Os 3 arquivos de ${typeDocumentation}, já foram adicionados !</h2><br><button>Ok</button>`
        );
        return;
      }
      switch (typeDocumentation) {
        case "HLTEXT":
          if (idFile === "fileInput") {
            const divHolerite = document.getElementById(`describe-holerite`);
            const describe =
              "3 últimos holetires ou 6 últimos meses de extrato bancário";
            divHolerite.innerHTML = "";

            filesArray[filesArray.length - 1].TitularConjuge = "T";
            const filesParsedHolerite = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "T"
            );
            showFilesInDiv(filesParsedHolerite, divHolerite, describe, typeDocumentation);
          } else {
            const divHoleriteMarital = document.getElementById(
              `describe-holerite-marital`
            );
            const describeHoleriteMarital =
              "3 últimos holetires ou 6 últimos meses de extrato bancário";
            divHoleriteMarital.innerHTML = "";
            filesArray[filesArray.length - 1].TitularConjuge = "C";
            const filesParsedHoleriteMarital = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "C"
            );

            showFilesInDiv(
              filesParsedHoleriteMarital,
              divHoleriteMarital,
              describeHoleriteMarital,
              typeDocumentation
            );
          }

          break;
        case "IDENT":
          if (idFile === "fileInputID") {
            const divIdentidade = document.getElementById(`describe-identidade`);
            const describeIdentidade = "RG e CPF, CNH ou RNE";
            divIdentidade.innerHTML = "";
            filesArray[filesArray.length - 1].TitularConjuge = "T";
            const filesParsedIdentidade = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "T"
            );

            showFilesInDiv(
              filesParsedIdentidade,
              divIdentidade,
              describeIdentidade,
              typeDocumentation
            );
          } else {
            const divIdentidadeMarital = document.getElementById(
              `describe-identidade-marital`
            );
            const describeIdentidadeMarital = "RG e CPF, CNH ou RNE";
            divIdentidadeMarital.innerHTML = "";
            filesArray[filesArray.length - 1].TitularConjuge = "C";
            const filesParsedIdentidadeMarital = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "C"
            );

            showFilesInDiv(
              filesParsedIdentidadeMarital,
              divIdentidadeMarital,
              describeIdentidadeMarital,
              typeDocumentation
            );
          }

          break;

       //@ts-ignore
        case "ctps":
          if (idFile === "fileInputCTPS") {
            const divCTPS = document.getElementById(`describe-ctps`);
            const describeCTPS =
              " CTPS nas páginas: foto, qualificação civil, último contrato de trabalho e FGTS";
            divCTPS.innerHTML = "";

            filesArray[filesArray.length - 1].TitularConjuge = "T";

            const filesParsedCTPS = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "T"
            );

            showFilesInDiv(filesParsedCTPS, divCTPS, describeCTPS, typeDocumentation);
            break;
          } else {
            const divCTPSMarital = document.getElementById(`describe-ctps-marital`);
            const describeCTPSMarital =
              " CTPS nas páginas: foto, qualificação civil, último contrato de trabalho e FGTS";
            divCTPSMarital.innerHTML = "";

            filesArray[filesArray.length - 1].TitularConjuge = "C";
            const filesParsedCTPSMarital = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "C"
            );

            showFilesInDiv(
              filesParsedCTPSMarital,
              divCTPSMarital,
              describeCTPSMarital,
              typeDocumentation
            );
          }

        case "CERTESTCIV":
          if (idFile == "fileInputEstadoCivil") {
            const divEstadoCivil = document.getElementById(`describe-estadoCivil`);
            const describeEstadoCivil =
              "  Certidão de Nascimento (para solteiros) ou Certidão de casamento";
            divEstadoCivil.innerHTML = "";

            filesArray[filesArray.length - 1].TitularConjuge = "T";
            const filesParsedEstadoCivil = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "T"
            );

            showFilesInDiv(
              filesParsedEstadoCivil,
              divEstadoCivil,
              describeEstadoCivil,
              typeDocumentation
            );
          }

          break;

        case "IRPF":
          if (idFile == "fileInputIR") {
            const divIR = document.getElementById(`describe-ir`);
            const describeIR = "IRPF ANO ANTERIOR - com renda minima declarada";
            divIR.innerHTML = "";
            filesArray[filesArray.length - 1].TitularConjuge = "T";
            const filesParsedIR = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "T"
            );
            showFilesInDiv(filesParsedIR, divIR, describeIR, typeDocumentation);
          } else {
            const divIRMarital = document.getElementById(`describe-ir-marital`);
            const describeIRMarital =
              "IRPF ANO ANTERIOR - com renda minima declarada";
            divIRMarital.innerHTML = "";

            filesArray[filesArray.length - 1].TitularConjuge = "C";

            const filesParsedIRMarital = filesArray.filter(
              (filter) => filter.type === typeDocumentation && filter.TitularConjuge == "C"
            );

            showFilesInDiv(
              filesParsedIRMarital,
              divIRMarital,
              describeIRMarital,
              typeDocumentation
            );
          }

          break;

        case "holerite-marital":
          const divHoleriteMarital = document.getElementById(
            `describe-holerite-marital`
          );
          const describeHoleriteMarital =
            "3 últimos holetires ou 6 últimos meses de extrato bancário";
          divHoleriteMarital.innerHTML = "";
          const filesParsedHoleriteMarital = filesArray.filter(
            (filter) => filter.type === typeDocumentation
          );

          filesArray[filesArray.length - 1].TitularConjuge = "T";

          showFilesInDiv(
            filesParsedHoleriteMarital,
            divHoleriteMarital,
            describeHoleriteMarital,
            typeDocumentation
          );
          break;

        case "identidade-marital":
          const divIdentidadeMarital = document.getElementById(
            `describe-identidade-marital`
          );
          const describeIdentidadeMarital = "RG e CPF, CNH ou RNE";
          divIdentidadeMarital.innerHTML = "";
          const filesParsedIdentidadeMarital = filesArray.filter(
            (filter) => filter.type === typeDocumentation
          );

          filesArray[filesArray.length - 1].TitularConjuge = "C";

          showFilesInDiv(
            filesParsedIdentidadeMarital,
            divIdentidadeMarital,
            describeIdentidadeMarital,
            typeDocumentation
          );
          break;

        case "ctps-marital":
          const divCTPSMarital = document.getElementById(`describe-ctps-marital`);
          const describeCTPSMarital =
            " CTPS nas páginas: foto, qualificação civil, último contrato de trabalho e FGTS";
          divCTPSMarital.innerHTML = "";
          const filesParsedCTPSMarital = filesArray.filter(
            (filter) => filter.type === typeDocumentation
          );

          filesArray[filesArray.length - 1].TitularConjuge = "C";

          showFilesInDiv(
            filesParsedCTPSMarital,
            divCTPSMarital,
            describeCTPSMarital,
            typeDocumentation
          );
          break;

        case "ir-marital":
          const divIRMarital = document.getElementById(`describe-ir-marital`);
          const describeIRMarital =
            "IRPF ANO ANTERIOR - com renda minima declarada";
          divIRMarital.innerHTML = "";

          filesArray[filesArray.length - 1].TitularConjuge = "C";

          const filesParsedIRMarital = filesArray.filter(
            (filter) => filter.type === typeDocumentation
          );
          showFilesInDiv(
            filesParsedIRMarital,
            divIRMarital,
            describeIRMarital,
            typeDocumentation
          );
          break;

        case "age-marital":
          const divAgeMarital = document.getElementById(`describe-age-marital`);
          const describeAgeMarital =
            "Certidão de Nascimento (para solteiros) ou Certidão de casamento";
          divAgeMarital.innerHTML = "";

          filesArray[filesArray.length - 1].TitularConjuge = "C";

          const filesParsedAgeMarital = filesArray.filter(
            (filter) => filter.type === typeDocumentation
          );
          showFilesInDiv(
            filesParsedAgeMarital,
            divAgeMarital,
            describeAgeMarital,
            typeDocumentation
          );
          break;

                
      }
    }
  }, [filesArray]); 

   useEffect(() => {
    // Atualizar o estado interno quando a propriedade isOpen mudar
    setInternalIsOpen(isOpen);
  }, [isOpen]);

    return (
    <CustomModal open={isOpen} onCancel={onCancel} footer={null}>
      <ContainerModal>
        <div className="modal-documentation-header">
          <h2>Documentação</h2>
          <p>
            Envie os documentos listados abaixo. Os documentos devem estar
            totalmente legíveis e preferencialmente em formato PDF.
          </p>
          <p> - Tamanho máximo por documento: 5 MB</p>
          <p> - Envie até 3 anexos por tipo de documento</p>
          <p style={{ fontSize: '11px' }}>*Documentos obrigatórios.</p>
        </div>
        <ModalDocumentaionContainer className="modal-documentation-customer" >
          <div className="circular-progress-container hide" id="loading-modal">
            <div
              className="mdc-circular-progress mdc-circular-progress--indeterminate mdc-circular-progress--large"
              role="progressbar"
              aria-label="Example Progress Bar"
              aria-valuemin={0}
              aria-valuemax={1}
              data-mdc-auto-init="MDCCircularProgress"
            >
              <div className="mdc-circular-progress__determinate-container">
                <svg
                  className="mdc-circular-progress__determinate-circle-graphic"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    className="mdc-circular-progress__determinate-circle"
                    cx="16"
                    cy="16"
                    r="12.5"
                    strokeDasharray="78.54"
                    strokeDashoffset="78.54"
                  />
                </svg>
              </div>
              <div className="mdc-circular-progress__indeterminate-container">
                <div className="mdc-circular-progress__spinner-layer">
                  <div className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left">
                    <svg
                      className="mdc-circular-progress__indeterminate-circle-graphic"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="16"
                        cy="16"
                        r="12.5"
                        strokeDasharray="78.54"
                        strokeDashoffset="39.27"
                      />
                    </svg>
                  </div>
                  <div className="mdc-circular-progress__gap-patch" />
                  <div className="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right" />
                </div>
              </div>
            </div>
          </div>
          <p id="title-customer" style={{left: '2% !important', top: '-1em !important'}} />
          <table>
            <tr>
              <th>Documento</th>
              <th>Descrição</th>
              <th></th>
            </tr>
            <tr>
              <td>*Holerites e/ou extrato bancário</td>
              <ContainerTD id="describe-holerite">
                3 últimos holetires ou 6 últimos meses de extrato bancário
              </ContainerTD>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInput"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event, 'HLTEXT', 'fileInput')}
                />
                <button
                  className="follow-button"
                  onClick={() => {
                    selectFiles('fileInput');
                  }}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>*Documento de identidade</td>
              <ContainerTD id="describe-identidade">RG e CPF, CNH ou RNE</ContainerTD>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputID"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'IDENT', 'fileInputID')}
                />
                <button
                  className="follow-button"
                  onClick={() => {
                    selectFiles('fileInputID');
                  }}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>CTPS</td>
              <ContainerTD id="describe-ctps">
                CTPS nas páginas: foto, qualificação civil, último contrato de
                trabalho e FGTS
              </ContainerTD>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputCTPS"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'ctps','fileInputCTPS')}
                />
                <button
                  className="follow-button"
                  onClick={() => selectFiles('fileInputCTPS')}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>*Certidão de estado civil</td>
              <ContainerTD id="describe-estadoCivil">
                Certidão de Nascimento (para solteiros) ou Certidão de casamento
              </ContainerTD>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputEstadoCivil"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'CERTESTCIV', 'fileInputEstadoCivil')
                  }
                />
                <button
                  className="follow-button"
                  onClick={() => {
                    selectFiles('fileInputEstadoCivil');
                  }}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>Declaração de Imposto de Renda</td>
              <ContainerTD id="describe-ir">
                IRPF ANO ANTERIOR - com renda minima declarada
              </ContainerTD>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputIR"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'IRPF', 'fileInputIR')}
                />
                <button
                  className="follow-button"
                  onClick={ ()=> selectFiles('fileInputIR')}
                >
                  Anexar
                </button>
              </td>
            </tr>
          </table>
        </ModalDocumentaionContainer>
        <br />
        <ModalDocumentaionContainer className="modal-documentation-customer" id="spouse-doc">
          <p>Cônjuge</p>
          <table>
            <tr>
              <th>Documento</th>
              <th>Descrição</th>
              <th></th>
            </tr>
            <tr>
              <td>Holerites e/ou extrato bancário</td>
              <td id="describe-holerite-marital">
                3 últimos holetires ou 6 últimos meses de extrato bancário
              </td>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputConjugeHolerite"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'HLTEXT', 'fileInputConjugeHolerite')
                  }
                />
                <button
                  className="follow-button"
                  onClick={() => selectFiles('fileInputConjugeHolerite')}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>*Documento de identidade</td>
              <td id="describe-identidade-marital">RG e CPF, CNH ou RNE</td>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputConjugeIdentidade"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'IDENT', 'fileInputConjugeIdentidade')
                  }
                />
                <button
                  className="follow-button"
                  onClick={() => selectFiles('fileInputConjugeIdentidade')}
                >
                  Anexar
                </button>
              </td>
            </tr>
            <tr>
              <td>CTPS</td>
              <td id="describe-ctps-marital">
                CTPS nas páginas: foto, qualificação civil, último contrato de
                trabalho e FGTS
              </td>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputConjugeFGTS"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'ctps', 'fileInputConjugeFGTS')}
                />
                <button
                  className="follow-button"
                  onClick={() => selectFiles('fileInputConjugeFGTS')}
                >
                  Anexar
                </button>
              </td>
            </tr>

            <tr>
              <td>Declaração de Imposto de Renda</td>
              <td id="describe-ir-marital">
                IRPF ANO ANTERIOR - com renda minima declarada
              </td>
              <td style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  id="fileInputConjugeIR"
                  multiple
                  accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                  style={{ display: 'none' }}
                  onChange={(event) => handleFiles(event,'IRPF', 'fileInputConjugeIR')}
                />
                <button
                  className="follow-button"
                  onClick={() => selectFiles('fileInputConjugeIR')}
                >
                  Anexar
                </button>
              </td>
            </tr>
          </table>
        </ModalDocumentaionContainer>

        <DivModalFooter className="modal-footer-simulation">
          <div>
            <button
              id="button-documetation"
              style={{ padding: '1em !important' }}
              onClick={() => SendDocumentations()}
            >
              ENVIAR DOCUMENTOS
            </button>
            <p />
          </div>
          <div>
            <button
              id="button-withoutDocumetation"
              onClick={() => closeAfterPost()}
            >
              SEGUIR SEM DOCUMENTAÇÃO
            </button>
            <p>
              *Em até 24 horas, um dos nossos especialistas entrará em contato
              para solicitar mais detalhes sobre os dados complementares
              informados.
            </p>
          </div>
        </DivModalFooter>
      </ContainerModal>
    </CustomModal>
    )
}

export default ModalDataDocumentation;